<template>
  <div>
    <card-my-teams />
  </div>
</template>
<script>
/* 
  Class: MyTeams
  Description: This class representing a main entry point for user teams.
*/

/* Imports */
import CardMyTeams from '@/components/Cards/Teams/CardMyTeams.vue';
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: '%s | ' + this.$route.name
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
      CardMyTeams
  }
}
</script>